export default __webpack_public_path__ + "../staticImages/kastagnetten-260.png";